import { stringToColor } from '@mahawi/eshop-common/src/string-to-color';
import { Tag } from 'antd';
import React from 'react';

function getContrastTextColor(hex: string): string {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return (r * 299 + g * 587 + b * 114) / 1000 >= 128 ? '#000000' : '#ffffff';
}

function StatusTag({
  status,
  label,
}: {
  status: string;
  label?: string;
}): React.ReactElement {
  const color = stringToColor(status);

  return (
    <Tag
      style={{
        backgroundColor: color,
        borderColor: color,
        color: getContrastTextColor(color),
      }}
    >
      {label ?? status}
    </Tag>
  );
}

export default StatusTag;
